

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVEBLOGSECTION
// APPROVEBLOGSECTION


const APPROVEBLOGSECTION= createAsyncThunk(
  "approveBlogSection/approveBlogSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveBlogSectionSlice = createSlice({
  name: "approveBlogSectionSlice",
  initialState: {
    approveBlogSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveBlogSection: (state) => {
        state.approveBlogSection.loading = false
        state.approveBlogSection.error = false
        state.approveBlogSection.data = []
        state.approveBlogSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEBLOGSECTION.fulfilled, (state, action) => {
      state.approveBlogSection = {
        ...state.approveBlogSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEBLOGSECTION.pending, (state, action) => {
      state.approveBlogSection = {
        ...state.approveBlogSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEBLOGSECTION.rejected, (state, action) => {
      state.approveBlogSection = {
        ...state.approveBlogSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveBlogSectionAction = {
    APPROVEBLOGSECTION,
};

export { approveBlogSectionAction };
export default approveBlogSectionSlice.reducer;
export const {setInitialStateOfapproveBlogSection} = approveBlogSectionSlice.actions
